var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-content-filters"},[_c('header-mobile-page',{attrs:{"label":_vm.child.name}}),_c('div',{staticClass:"header"},[_vm._v("\n    Custom Content Filters\n  ")]),_c('custom-content-filter',{attrs:{"mode-id":_vm.modeId,"child-id":_vm.childId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }